import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileAnalyticsComponent } from './mobile-analytics.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModuleMobi } from '../material/material.module';
import { SharedModule } from 'shared-library';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,ReactiveFormsModule,
    MaterialModuleMobi,
    SharedModule
  ],
  exports:[MobileAnalyticsComponent],
  declarations: [MobileAnalyticsComponent]
})
export class MobileAnalyticsModule { }
